import React, {useCallback, useEffect, useRef, useState} from "react";
import {renderMarkdown} from "../../markdown/markdown-factory";
import AnimateHeight from "react-animate-height";

const CollapsibleText = ({
                           className = null,
                           isOpen: controllerOpen = false,
                           onToggle : controllerToggle = null,
                           text = "",
                           // TODO: specify lines instead of chars
                           visibleChars = 160,
                           minimumHidden = 80,
                           markText = null,
                           toggle = "more", // "more" | "disclosure" | "title"
                           showPreview = true,
                         }) => {

  const [isOpen, setIsOpen] = useState(controllerOpen);
  const textRef = useRef();
  const [hasOverflow, setHasOverflow] = useState(false);
  const [height, setHeight] = useState('auto');
  const onToggle = controllerToggle || (() => setIsOpen(!isOpen));
  let forceOpen = false;

  useEffect(() => {
    setIsOpen(controllerOpen);
  }, [controllerOpen, controllerToggle]);

  text = text
    .replace(/(\s*<br\/>\s*)+/gi, "\n").trim()
    .replace(/\n+/gi, "<br class='newline' />");

  if (markText) {
    const marked = markText(text, {asString: true});
    if (typeof marked === 'string' ? marked !== text : marked?.includes?.('<mark')) {
      forceOpen = true;
    }
  }

  const onMount = useCallback(node => {
    if (node != null) {
      textRef.current = node;
      if (!isOpen && !forceOpen) {
        // Only sample the height when not expanded
        if (node.scrollHeight > node.clientHeight) {
          setHasOverflow(true);
        }
      }
    }
  }, [isOpen, forceOpen]);

  const rendered = renderMarkdown({markdown: text, markText});
  useEffect(() => {
    if (textRef.current) {
      const resizeObserver = new ResizeObserver(() => {
        setHeight(textRef.current.clientHeight);
      });
      resizeObserver.observe(textRef.current);
      return () => resizeObserver.disconnect();
    }
  }, []);

  // Determine toggle display based on toggle mode
  const showToggleControl = hasOverflow && !forceOpen && toggle !== "title";
  const isDisclosureMode = toggle === "disclosure";

  return (
    <span className={`collapsible-text collapsible${className ? ' ' + className : ''}`}>
      {text.length === 0 ? null : (
        <>
          <AnimateHeight
            duration={500}
            disableDisplayNone
            height={showPreview ? height : 'auto'}>
            <span key="text-content"
                  ref={showPreview ? onMount : null}
                  className={`${isOpen || forceOpen ? "expanded" : "collapsed"}${hasOverflow ? " with-overflow" : ""}`}>
              {rendered}
            </span>
          </AnimateHeight>
          {showToggleControl && (
            <span key="toggle"
                  className={`collapse-toggler${isDisclosureMode ? ' disclosure-triangle' : ''}`}
                  onClick={onToggle}>
              {isDisclosureMode ? (isOpen || forceOpen ? "▼" : "▶") : (isOpen || forceOpen ? "less" : "more")}
            </span>
          )}
        </>
      )}
    </span>
);
};

export default CollapsibleText;
